import { DefaultActive, SchedulerData, SchedulerSegment } from './types';
import { getDividedHours, getFirstHour, getHours } from '@components/scheduler/grid/helpers';
import { defaultAppearance } from '@forms/panel/workflows/task/constants';
import { tenantNow } from '@utils/timeZone';
import { getShiftDates } from '@utils/schedule/tenantShift';

export const START_HOUR: number = 6;
export const HOURS_COUNT: number = 13;

export const getDefaultStartsAt = () => getShiftDates(tenantNow()).startsAt;

export const getDefaultEndsAt = () => getShiftDates(tenantNow()).endsAt;

export const defaultActive: DefaultActive = {
  schedule: {
    id: '',
    foreman: { id: '' },
    startsAt: '',
    endsAt: '',
    status: '',
    task: {
      id: '',
      name: '',
      job: {
        id: '',
        projectId: '',
        name: '',
        address: '',
        division: { id: '', name: '' },
      },
      stage: {
        id: '',
        name: '',
      },
      appearance: defaultAppearance,
    },
  },
  newValues: {},
  fresh: false,
  foremanChanged: false,
  mode: 'move',
  initialX: 0,
  cursor: 'cursor-auto',
  x: 0,
  y: 0,
};

const initialSegment: SchedulerSegment = {
  length: 15,
  count: 60 / 15,
  width: `calc(100%/${60 / 15})`,
};

export const initialState: SchedulerData = {
  segment: initialSegment,
  dayStart: START_HOUR,
  hoursCount: HOURS_COUNT,
  showFullDay: false,
  showFullDayOverridden: false,
  outOfScopeRecords: false,
  date: getFirstHour(new Date()),
  data: {
    raw: {
      foremen: [],
      withoutTeam: [],
    },
    grouped: {
      foremen: [],
      withoutTeam: [],
    },
  },
  hours: getDividedHours(getHours(new Date()), initialSegment),
  modal: false,
  inventory: false,
  active: defaultActive,
};
